import { createFileRoute } from "@tanstack/react-router";

import { VerifyOtpRouteComponent } from "@/route-components/VerifyOtpRouteComponent";

import { requireAuth } from "../../utils/routeGuards";

export const Route = createFileRoute("/auth/verify-otp")({
  beforeLoad: ({ location }) => requireAuth(location),
  validateSearch: (search: Record<string, unknown>) => {
    return {
      mode: search.mode === "phone" ? ("phone" as const) : search.mode === "email" ? ("email" as const) : undefined,
      phone: typeof search.phone === "string" ? search.phone : undefined,
      email: typeof search.email === "string" ? search.email : undefined,
      from: typeof search.from === "string" ? search.from : undefined,
    };
  },
  component: VerifyOtpRouteComponent,
});
